import * as yup from "yup";

const ClockOverrideSchema = yup.object().shape({
  clock_type: yup
    .string()
    .oneOf(["clock_in", "clock_out", "no_show"], "Please select a valid type")
    .required("Type is required"),
  timestamp: yup.string().when("clock_type", {
    is: "no_show",
    then: yup.string().notRequired(),
    otherwise: yup
      .string()
      .required("Time is required")
      .matches(
        /^([01]\d|2[0-3]):([0-5]\d)$/,
        "Time must be in HH:MM format (e.g., 08:30)"
      ),
  }),
  reason: yup
    .string()
    .max(500, "Reason must be at most 500 characters")
    .notRequired(),
  no_show_reason: yup.string().when("clock_type", {
    is: "no_show",
    then: yup.string().required("Reason is required"),
    otherwise: yup.string().notRequired(),
  }),
  no_show_reason_other: yup.string().when("no_show_reason", {
    is: "Other",
    then: yup
      .string()
      .required("Please specify a reason")
      .max(500, "Reason must be at most 500 characters"),
    otherwise: yup.string().notRequired(),
  }),
});

export default ClockOverrideSchema;
